import React, { Component } from "react";
import ReactDOM from "react-dom";
import { default as SelectPlugin, components } from "react-select";
import { isFieldValidClass, insertParam } from "~/js/utils";
import isEqual from "lodash.isequal";
import {Checkbox} from "./Checkbox";

const NOOP = () => {};
const NOOP_REACT_SELECT_STYLES = {
    // clearIndicator: NOOP,
    // container: NOOP,
    control: NOOP,
    dropdownIndicator: NOOP,
    // group: NOOP,
    // groupHeading: NOOP,
    indicatorsContainer: NOOP,
    indicatorSeparator: NOOP,
    input: (base) => {
        return { ...base, paddingBottom: 0, paddingTop: 0, margin: 0 };
    },
    // loadingIndicator: NOOP,
    // loadingMessage: NOOP,
    menu: NOOP,
    menuList: NOOP,
    // menuPortal: NOOP,
    // multiValue: NOOP,
    // multiValueLabel: NOOP,
    // multiValueRemove: NOOP,
    // noOptionsMessage: NOOP,
    option: NOOP,
    placeholder: NOOP,
    // singleValue: NOOP,
    valueContainer: NOOP,
};

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <Checkbox
                    label={{ text: `${props.label}` }}
                    checked={props.isSelected}
                    onChange={() => null}
                    modifiers={['multiCheckbox']}

                />
            </components.Option>
        </div>
    );
};
const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <div className="select__arrow">
                <svg
                    width="13"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.627 1.066l-5 5M6.627 6.066l-5-5"
                        stroke="#1D1D1D"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            </div>
        </components.DropdownIndicator>
    );
};

class SelectMultiFilters extends Component {
    handleChange = (selectedOption) => {
        const { onChange } = this.props;
        if (onChange) {
            onChange(selectedOption);
        }
    };

    handleBlur = (e) => {
        const { form, name } = this.props;
        if (form) {
            form.setFieldTouched(name, true);
            form.handleBlur(e);
        }
    };

    render() {
        const { modifiers, pre, value, ...rest } = this.props;

        let className = `select`;
        if (modifiers) modifiers.forEach((m) => (className += ` select--${m}`));
        if (value) {
            if (value.length === 0) className += ` is-empty-selected`;
            else className += ` is-value-selected`;
        }

        const customStyles = {
            ...NOOP_REACT_SELECT_STYLES,
            option: (provided, state) => ({
                display: 'flex',
                alignItems: 'center',
            }),
        };
        return (
            <div className={className}>
                {pre ? <div className="select__pre">{pre}</div> : null}
                <SelectPlugin
                    isSearchable={false}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    className={`select__wrap`}
                    classNamePrefix="select"
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    value={value}
                    menuShouldCloseOnBlur={false}
                    isClearable={false}
                    {...rest}
                    components={{
                        DropdownIndicator,
                        Option,
                        MultiValue: CustomMultiValue,  // Hide selected items in input
                        ValueContainer: CustomValueContainer,  // Show the selected count in placeholder
                    }}
                    styles={customStyles}
                />
            </div>
        );
    }
}

const CustomMultiValue = () => null;


const CustomValueContainer = ({ children, ...props }) => {
    const { getValue, selectProps } = props;
    const selected = getValue();
    const count = selected.length;

    // Placeholder text logic
    let text = selectProps.placeholder || "All makes"; // Default placeholder

    if(count == 1){
        text = `${selected[0].label ?? "Makes (${count})"}`; // Example: "Makes (3)"

    }
    if (count > 1) {
        text = `${selectProps.placeholderName ?? "Makes"} (${count})`; // Example: "Makes (3)"
    }

    return (
        <components.ValueContainer {...props}>
            <div style={{ marginLeft: '2px' }}>
                {text} {/* Custom placeholder */}
            </div>
            <style jsx>{`
                .select__placeholder {
                    display: none;
                }
            `}</style>
            {/* Ensure the input field is still rendered here */}
            {children}
        </components.ValueContainer>
    );
};


const SelectMultiFiltersWithRef = React.forwardRef((props, ref) => (
    <SelectMultiFilters {...props} innerRef={ref} />
));

export { SelectMultiFiltersWithRef as SelectMultiFilters };
